import { useActiveOrganizationId } from '@xhubio-saas/core-frontend/kernel'
import type { ReactNode } from 'react'
import { trpc } from '@/trpc'
import {
  type EntitlementRestriction,
  EntitlementRestrictionContext,
} from './EntitlementRestrictionContext'

/**
 * Fetches billing entitlements from the backend and provides them
 * to the EntitlementRestrictionContext.
 *
 * This enables usePermissions() to combine RBAC + billing checks.
 *
 * Gegatet auf die aktive Organisation, nicht auf die Sitzung (Plan ALLGEMEIN
 * 2026-09-26/01, S4 Teil 1): `getBillingEntitlements` ist eine
 * `organizationProcedure` und lehnt ein eingeladenes Mitglied ohne
 * Mitgliedschaft mit 403 ab. Eine Absage wird nicht wiederholt.
 */
export function BillingEntitlementProvider({ children }: { children: ReactNode }) {
  const activeOrganizationId = useActiveOrganizationId()
  const { data, isLoading } = trpc.billing.getBillingEntitlements.useQuery(undefined, {
    enabled: !!activeOrganizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  })

  const value: EntitlementRestriction = {
    billingEntitlements: data?.entitlements ?? null,
    isLoading,
  }

  return (
    <EntitlementRestrictionContext.Provider value={value}>
      {children}
    </EntitlementRestrictionContext.Provider>
  )
}
